// GENERATED by client/verify/bake-cemeteries.mts — DO NOT EDIT. Rebake with `npm run bake:cemeteries` after bake:plans.
// Every settlement's burial precinct: [x, z, yaw, hw, hd] (world metres; yaw in the STANDARD frame — local +z points away
// from the town, the gate on the −z side faces it, rows grow outward). Read by hinterland.cemeterySpot (client) and
// lib/cemetery.cemeterySpot (server); the two files are byte-identical.
export const CEMETERY_SPOTS: Record<string, Record<number, [number, number, number, number, number]>> = {
  "commons-genesis": {
    0: [-98.63, -316.86, 8.5729, 20, 12],
    1: [897920.51, -252549.09, 9.9389, 20, 12],
    2: [801902.74, 577987.77, 3.0299, 20, 12],
    3: [12697.72, 73062.06, 4.5205, 20, 12],
    4: [902009.59, -262322.1, 4.6022, 20, 12],
    5: [-1295.16, 3174.33, 4.7331, 20, 12],
    6: [-218814.64, 450691.15, 5.7689, 20, 12],
    7: [390851.28, -341298.49, 5.6341, 20, 12],
    8: [478218.54, -117749.92, 2.8886, 20, 12],
    9: [466238.97, -118220.45, 3.022, 20, 12],
    10: [447487.54, -101365.44, 8.3561, 20, 12],
    11: [-726940.42, -504076.85, 6.4741, 20, 12],
    12: [-11525.92, 80.29, 3.2606, 16, 10],
    13: [-712667.29, -505864.67, 0.2305, 16, 10],
    14: [6269.57, 75968.93, 4.7821, 16, 10],
    15: [-236272.9, 445656.05, 3.2567, 16, 10],
    16: [23604.75, 52591.47, 1.4496, 16, 10],
    17: [925027.56, -242553.76, 5.5947, 16, 10],
    18: [-719864.63, -505643.4, 4.6312, 16, 10],
    19: [806796.48, 575510.3, 6.6223, 16, 10],
    20: [2476.26, 9926.8, 5.921, 16, 10],
    21: [924981.61, -246204.21, 5.0485, 16, 10],
    22: [6319.38, 66786.8, 1.4204, 16, 10],
    23: [459951.8, -103283.62, 5.7743, 16, 10],
    24: [-216690.5, 461460.42, 4.527, 16, 10],
    25: [-211721.45, 439104.68, 2.8763, 16, 10],
    26: [-15236.12, 12310.97, -0.6066, 16, 10],
    27: [924089.91, -249276.9, 5.2583, 16, 10],
    28: [24781.51, 79657.53, 8.5287, 16, 10],
    29: [828.27, 54912.75, 5.7982, 16, 10],
    30: [447789.9, -92897.76, 3.8201, 16, 10],
    31: [907724.44, -259689.85, 5.9231, 16, 10],
    32: [-777.31, 5624.22, 5.219, 16, 10],
    33: [5078.66, 77871.08, 5.9605, 16, 10],
    34: [-883.45, 76334.18, 1.4594, 16, 10],
    35: [-223771.07, 453475.02, 5.641, 16, 10],
    36: [-727763.01, -531814.88, 4.5498, 16, 10],
    37: [-737004.01, -522395.42, 5.7241, 16, 10],
    38: [7536.27, 53793.45, 4.9357, 16, 10],
    39: [-216215.22, 445328.9, 4.7307, 16, 10],
    40: [27028.72, 69790.2, 8.6016, 16, 10],
    41: [-739667.87, -521728.35, 5.1346, 16, 10],
    42: [910408.56, -259960.02, 1.7362, 16, 10],
    43: [4457.07, 57946.63, 4.8436, 16, 10],
    44: [4813.02, -3322.34, 0.2686, 16, 10],
    45: [-715708.32, -511291.81, 3.8536, 16, 10],
    46: [908561.58, -244668.59, 6.7442, 16, 10],
    47: [13424.33, 14005.83, 5.5862, 16, 10],
    48: [17875.48, 73572.73, 0.5761, 16, 10],
    49: [394751.56, -351830.59, 5.4824, 16, 10],
    50: [-9797.95, -134.6, 6.4725, 16, 10],
    51: [458560.4, -95192.83, 6.2096, 16, 10],
    52: [899447.57, -259796.24, 3.8511, 16, 10],
    53: [465874.39, -111464.83, 5.6047, 16, 10],
    54: [-734978.6, -528399.04, 4.5838, 16, 10],
    55: [365429.52, -350330.01, 4.5124, 16, 10],
    56: [384051.54, -355646.96, -0.7904, 16, 10],
    57: [382198.84, -350304.76, 5.0051, 16, 10],
    58: [3788.6, -11096.11, 5.6363, 16, 10],
    59: [455947.13, -112107.95, 5.2823, 16, 10],
    60: [25538.87, 66601.54, 6.4831, 16, 10],
    61: [-4252.42, -8525.27, 4.5341, 16, 10],
    62: [476211.96, -112085.57, 8.7892, 16, 10],
    63: [19954.16, 54602.74, 4.9251, 16, 10],
    64: [905322.34, -236122.31, 1.7789, 16, 10],
    65: [10152.7, 72873.21, 5.2222, 16, 10],
    66: [-729440.31, -533819.17, 2.1515, 16, 10],
    67: [-218481.06, 444793.5, 0.4289, 16, 10],
    68: [-9738.62, 1785.22, 5.7718, 16, 10],
    69: [7077.44, 12482.02, 5.0453, 16, 10],
    70: [459071.19, -122428.88, 6.7548, 16, 10],
    71: [13347.42, -10386.63, 2.5175, 16, 10],
    72: [911426.58, -240798.96, 0.5524, 11, 8],
    73: [-739354.68, -509214.23, 4.4756, 11, 8],
    74: [447675.94, -122940.37, 5.3024, 11, 8],
    75: [16212.96, 77937.99, 4.5494, 11, 8],
    76: [-235921.64, 453183.3, -0.354, 11, 8],
    77: [913902.73, -247848.91, 4.9276, 11, 8],
    78: [-233689.26, 450445.18, 4.9277, 11, 8],
    79: [367446.37, -344206.58, 0.2281, 11, 8],
    80: [-223803.95, 438745.14, 4.913, 11, 8],
    81: [-212930.39, 438290.71, 0.1425, 11, 8],
    82: [450347.07, -118915.36, 5.365, 11, 8],
    83: [-2575.39, 8453.44, 5.6061, 11, 8],
    84: [-712108.53, -530964.04, 4.8359, 11, 8],
    85: [388650.27, -343816.7, 4.823, 11, 8],
    86: [23694.26, 64959.93, -1.3865, 11, 8],
    87: [476462.33, -107047.11, 6.8509, 11, 8],
    88: [-235541.27, 445615.75, 0.5746, 11, 8],
    89: [26335.05, 75151.57, 5.9431, 11, 8],
    90: [-383.42, -180.06, 6.9255, 11, 8],
    91: [925678.41, -249024.21, 0.611, 11, 8],
    92: [4360.11, 14747.97, 6.4881, 11, 8],
    93: [18718.55, 60048.86, 4.4814, 11, 8],
    94: [26024.99, 58049.04, 5.5754, 11, 8],
    95: [-736371.89, -507134.18, 5.9561, 11, 8],
    96: [13609.14, 80161.75, 4.5015, 11, 8],
    97: [11847.79, 69831.31, 5.2512, 11, 8],
    98: [287.47, 11659.78, 4.9186, 11, 8],
    99: [-236269.62, 454101.74, 4.436, 11, 8],
    100: [-742286.22, -533985.49, 4.5255, 11, 8],
    101: [-232149.33, 444025.15, 4.5352, 11, 8],
    102: [-217240.75, 442116.34, 5.5795, 11, 8],
    103: [-2645.22, 10268.96, 0.5706, 11, 8],
    104: [911431.66, -245240.62, 6.429, 11, 8],
    105: [803845.8, 579712.28, 5.3524, 11, 8],
    106: [449903.37, -119344.51, 4.9581, 11, 8],
    107: [3553.22, 78006.34, 0.5377, 11, 8],
    108: [-737418.17, -513040.66, 5.3121, 11, 8],
    109: [921174.54, -237466.51, 0.1847, 11, 8],
    110: [11619.27, 11179.24, 5.26, 11, 8],
    111: [-15017.71, -6149.78, 6.5198, 11, 8],
    112: [-717142.03, -521439.87, 4.9065, 11, 8],
    113: [-221079.21, 442514.95, 4.4399, 11, 8],
    114: [466397.59, -120870.88, 0.2175, 11, 8],
    115: [816048.55, 574843.83, 5.3501, 11, 8],
    116: [387415.63, -345511.64, 5.3053, 11, 8],
    117: [8976.56, 84021.57, 5.5789, 11, 8],
    118: [13988.15, 1897.97, 4.8629, 11, 8],
    119: [469791.45, -105618.54, 4.493, 11, 8],
    120: [-1932.6, 82397.91, 5.9356, 11, 8],
    121: [458517.85, -117345.88, 5.0471, 11, 8],
    122: [460066.62, -105424.6, 4.5095, 11, 8],
    123: [15282.57, 12901.54, 4.9598, 11, 8],
    124: [906844.99, -262060.08, 5.5655, 11, 8],
    125: [-726315, -520072.61, 0.5634, 11, 8],
    126: [-237675.15, 455626.04, 0.1178, 11, 8],
    127: [392525.38, -338537.08, 5.5948, 11, 8],
    128: [1626.42, -7680.01, 5.2658, 11, 8],
    129: [472370.55, -104871.5, 4.9052, 11, 8],
    130: [384224.93, -345089.93, 0.2716, 11, 8],
    131: [452638.05, -122110.8, 5.2709, 11, 8],
    132: [411.07, 13468.39, 6.5148, 11, 8],
    133: [-718170.17, -521603.57, 4.4536, 11, 8],
    134: [-718195.47, -510413.54, 5.2663, 11, 8],
    135: [-737436.2, -528313.91, 5.2709, 11, 8],
    136: [804105.79, 572434.73, -0.3506, 11, 8],
    137: [-209833.11, 442354.14, 5.3547, 11, 8],
    138: [3249.32, 58344.63, 5.3154, 11, 8],
    139: [24700.75, 71576.39, 5.9491, 11, 8],
    140: [-739994.73, -526093.21, 4.9162, 11, 8],
    141: [-233112.22, 447319.66, 4.8459, 11, 8],
    142: [466774.88, -98926.8, 6.0389, 11, 8],
    143: [-220772.25, 440169.8, 4.473, 11, 8],
    144: [-719501.53, -514269.27, -0.9765, 11, 8],
    145: [905006.54, -250116.65, 0.2179, 11, 8],
    146: [-224509.82, 442684.74, 5.9328, 11, 8],
    147: [-712410.06, -532221.06, 6.8355, 11, 8],
    148: [-742058.84, -509614.4, 6.01, 11, 8],
    149: [464048.34, -112296.67, 5.5534, 11, 8],
    150: [-720369.46, -526576.92, 6.0389, 11, 8],
    151: [1114.68, 80908, 5.3533, 11, 8],
    152: [10109.3, 70489.26, 4.9205, 11, 8],
    153: [926852.82, -239671.14, 6.9099, 11, 8],
    154: [801561.47, 574970.97, 4.4409, 11, 8],
    155: [-210298.39, 466181.3, 4.5415, 11, 8],
    156: [2500.71, 61927.47, 5.9353, 11, 8],
    157: [-227253.92, 442412.19, 6.8216, 11, 8],
    158: [374791.05, -345106.18, 5.9351, 11, 8],
    159: [19093.89, 69470.9, -0.7742, 11, 8],
    160: [-725360.04, -508409.95, 4.8381, 11, 8],
    161: [-226991.87, 451283.35, 6.4087, 11, 8],
    162: [468126.04, -117234.62, 5.7388, 11, 8],
    163: [-741830.18, -504701.75, 4.879, 11, 8],
    164: [-741760.36, -516896.59, 4.8758, 11, 8],
    165: [-737369.64, -506130.06, -0.3271, 11, 8],
    166: [-227576.01, 440299.39, 4.9034, 11, 8],
    167: [902840.68, -251746.71, 5.5993, 11, 8],
    168: [-738302.96, -528530.23, -0.8999, 11, 8],
    169: [-717590.53, -527537.41, -0.834, 11, 8],
    170: [903719.3, -254013.17, 6.4271, 11, 8],
    171: [-725440.91, -509391.48, 4.4653, 11, 8],
    172: [-726206.42, -505220.66, 5.9345, 11, 8],
    173: [467243.26, -111005.67, 5.6108, 11, 8],
    174: [3281.81, 66021.67, 5.3158, 11, 8],
    175: [910355.05, -243574.92, 5.5886, 11, 8],
    176: [926587.27, -249088.77, 4.5026, 11, 8],
    177: [918203.68, -250198.45, 5.3032, 11, 8],
    178: [-5775.92, -2514.87, 0.5763, 11, 8],
    179: [387620.45, -346696.21, 5.4919, 11, 8],
    180: [12512.57, -6196.03, 6.635, 11, 8],
    181: [365666.88, -350548.78, 4.9403, 11, 8],
    182: [365488.51, -349385.19, 4.9558, 11, 8],
    183: [17162.09, 60870.51, 6.4173, 11, 8],
    184: [-740457.37, -513018.68, 6.9477, 11, 8],
    185: [-236624.12, 461355.4, 6.5297, 11, 8],
    186: [368627.21, -341035.44, 5.113, 11, 8],
    187: [22733.06, 71697.05, 4.9325, 11, 8],
    188: [-235704.37, 457588.14, 5.3601, 11, 8],
    189: [455835.45, -113705.12, 6.7361, 11, 8],
    190: [-740885.4, -531233.49, 0.1403, 11, 8],
    191: [927873.04, -246499.22, 5.3482, 11, 8],
    192: [910911.84, -247628.1, 4.9332, 11, 8],
    193: [-207578.28, 467831.75, 5.9337, 11, 8],
    194: [473154.87, -99721.24, 4.8393, 11, 8],
    195: [896858.81, -260104.2, 6.4057, 11, 8],
    196: [-230783.02, 467117.9, 5.2526, 11, 8],
    197: [900233.83, -253269.89, 6.8327, 11, 8],
    198: [376080.5, -348854.76, 4.5549, 11, 8],
    199: [-713701.66, -514697.53, 5.5229, 11, 8],
    200: [377307.16, -359270.49, 5.327, 11, 8],
    201: [1118.94, 12251.49, 4.8805, 11, 8],
    202: [18329.84, 59377.9, 5.6148, 11, 8],
    203: [-8509.06, 12613.52, 5.916, 11, 8],
    204: [455359.13, -107638.14, 6.4786, 11, 8],
    205: [12579.15, 14055.75, -0.6864, 11, 8],
    206: [6940.77, 63033.98, 4.4621, 11, 8],
    207: [926438.9, -239970.38, 6.8983, 11, 8],
    208: [-719754.53, -518768.77, 5.9971, 11, 8],
    209: [449406.27, -106930.18, 4.8845, 11, 8],
    210: [-228183.08, 461806.7, 6.0293, 11, 8],
    211: [380221.63, -353079.03, 5.3852, 11, 8],
    212: [-720209.74, -535173.27, 5.3494, 11, 8],
    213: [799704.06, 592143.16, 4.8636, 11, 8],
    214: [-223539.27, 438551.92, 5.9841, 11, 8],
    215: [807556.36, 587216.98, 5.2709, 11, 8],
    216: [463949.73, -95217.39, 6.8459, 11, 8],
    217: [-738857.3, -531164.23, 5.5881, 11, 8],
    218: [-3564.02, 58314.1, 10.7695, 11, 8],
    219: [900216.62, -250473.94, 6.2433, 11, 8],
    220: [23713.03, 67725.44, 5.5988, 11, 8],
    221: [-1679.39, 14536.98, 5.5377, 11, 8],
    222: [369443.69, -343313.78, 4.8808, 11, 8],
    223: [383236.76, -351017.35, 4.9158, 11, 8],
    224: [11906.11, 78909.43, 6.8256, 11, 8],
    225: [-228739.63, 444450.36, 6.5044, 11, 8],
    226: [-211976.28, 439481.39, 5.6001, 11, 8],
    227: [924555.49, -260128.63, 5.3435, 11, 8],
    228: [-2294.31, 77609.21, 5.6106, 11, 8],
    229: [904827.15, -257714.82, 5.3809, 11, 8],
    230: [391750.2, -364667.19, 5.3838, 11, 8],
    231: [13082.63, -9183.95, 4.9476, 11, 8],
    232: [924429.35, -261534.93, 4.9427, 11, 8],
    233: [10231.58, -5483.18, 5.9308, 11, 8],
    234: [475259.04, -94362.3, 5.2685, 11, 8],
    235: [-4379.4, -13909.56, 5.941, 11, 8],
    236: [449579.57, -98196.34, -0.7849, 11, 8],
    237: [9098.32, 80376, 5.5787, 11, 8],
    238: [908264.06, -257733.03, 5.4881, 11, 8],
    239: [22997.97, 60852.42, 5.9592, 11, 8],
    240: [465121.44, -121142.54, 4.4941, 11, 8],
    241: [909729, -236149.99, 4.8364, 11, 8],
    242: [469756.57, -104472.55, -1.3108, 11, 8],
    243: [-736679.44, -519112.27, -0.9121, 11, 8],
    244: [5090.1, 8695.55, 5.261, 11, 8],
    245: [-2539.83, 8988.5, 5.3587, 11, 8],
    246: [18966.32, 60705.98, 4.5203, 11, 8],
    247: [470351.8, -109454.93, 5.5825, 11, 8],
    248: [10637.25, 4664.16, 5.9328, 11, 8],
    249: [-728395.12, -503861.29, 5.1259, 11, 8],
    250: [12728.23, 1021.83, 4.516, 11, 8],
    251: [-729793.69, -519984.48, 5.3454, 11, 8],
    252: [-11382.27, -13253.09, 4.8806, 11, 8],
    253: [365761.57, -339886, 6.4177, 11, 8],
    254: [-735208.29, -518562.17, 4.8691, 11, 8],
    255: [-228058.03, 451392.29, 4.8563, 11, 8],
    256: [460410.71, -112576.88, 0.5946, 11, 8],
    257: [-732432.65, -516046.23, 0.5937, 11, 8],
    258: [-854.61, -3017.52, 5.4972, 11, 8],
    259: [-724920.59, -535291.35, 6.5007, 11, 8],
    260: [453745.2, -110724.3, 4.5494, 11, 8],
    261: [-213010.89, 467311.13, 4.8864, 11, 8],
    262: [6510.42, 1964.12, 4.5564, 11, 8],
    263: [20373.71, 57802.26, 4.9554, 11, 8],
    264: [806220.14, 579175.91, 6.8403, 11, 8],
    265: [-230740.94, 456064.81, 5.2706, 11, 8],
    266: [20444.45, 72349.08, 4.8617, 11, 8],
    267: [380784.45, -340764.78, 4.8859, 11, 8],
    268: [-722089.15, -525996.6, 4.8218, 11, 8],
    269: [-9006.02, 5313.29, 5.3653, 11, 8],
    270: [386106.82, -341606.89, 6.8985, 11, 8],
    271: [473268.17, -96132.53, 4.9093, 11, 8],
    272: [381239.76, -368208.82, 4.5536, 11, 8],
    273: [388040.3, -368562.08, 6.5112, 11, 8],
    274: [-734163.21, -527259.29, 4.9479, 11, 8],
    275: [-716584.22, -521623.77, 6.1101, 11, 8],
    276: [-712187.42, -506099.7, 4.4799, 11, 8],
    277: [-731891.6, -535060.29, 0.6089, 11, 8],
    278: [10100.43, 12135.7, 5.9054, 11, 8],
    279: [-716254.82, -513062.4, 4.4516, 11, 8],
    280: [19997.1, 68561.38, 0.1273, 11, 8],
    281: [1420.06, 72448.5, 4.8621, 11, 8],
    282: [-713195.59, -506239.87, 4.5086, 11, 8],
    283: [-234784.26, 453332.56, 4.9882, 11, 8],
    284: [6333.48, 73754.07, 4.9637, 11, 8],
    285: [7431.71, 57946.1, 5.2555, 11, 8],
    286: [-725315.14, -504286.63, 4.4625, 11, 8],
    287: [9173.26, 67863.26, 4.863, 11, 8],
    288: [-12006.32, 4765.26, 5.9999, 11, 8],
    289: [-737001.62, -515466.51, 5.5578, 11, 8],
    290: [13072.8, 65059.82, 4.4633, 11, 8],
    291: [-232074.95, 452586.07, 5.4937, 11, 8],
    292: [-739963.08, -516904.1, 4.8551, 11, 8],
    293: [475963.62, -111873.49, 5.3345, 11, 8],
    294: [-3075.41, 67494.3, 5.9311, 11, 8],
    295: [363933.42, -352706.64, 4.5081, 11, 8],
    296: [918133.04, -252933.77, 4.9223, 11, 8],
    297: [377005.88, -364160.71, 6.4189, 11, 8],
    298: [-214774.22, 441998.18, 4.4372, 11, 8],
    299: [2434.63, 74757.62, 4.4468, 11, 8],
    300: [919771.81, -246188.71, 4.499, 11, 8],
    301: [922872.53, -262621.96, 5.9666, 11, 8],
    302: [382342.71, -344839.2, 0.6319, 11, 8],
    303: [474790.53, -101744.22, 5.3559, 11, 8],
    304: [800398.42, 579902.72, 6.8331, 11, 8],
    305: [10862.83, -2085.22, 5.9302, 11, 8],
    306: [-716929.31, -515424.13, 5.285, 11, 8],
    307: [-222858, 461299.56, 5.4933, 11, 8],
    308: [-736744.49, -508619.05, 5.3853, 11, 8],
    309: [-5105.72, 12841.87, 4.9029, 11, 8],
    310: [903775.94, -261075.78, 4.8552, 11, 8],
    311: [-212408.64, 451110.08, -1.342, 11, 8],
    312: [-8055.43, -2869.39, 5.9902, 30, 16],
    313: [5422.93, -11893.35, 2.0973, 30, 16],
    314: [-1178.22, -10854.91, 6.7205, 12, 8],
  },
};
